import Navbar from "./NavBar";
import Footer from "./Footer";
import * as React from "react";
import {Outlet} from "react-router-dom";
import WhatsAppButton from "./Whatsapp";
import {Box, useTheme} from "@mui/material";
import {useApplication} from "../ApplicationProvider";
import ChatWidgetScreen from "../functionalities/chat_widget/ChatWidgetScreen";

export function AppLayout() {
    const theme = useTheme();
    const application = useApplication();
    const userEmail = application.session().user().email;
    const showChatWidget = userEmail.includes("@eryxsoluciones.com.ar") || userEmail.includes("@eryx.co") || userEmail === "leandro.muscat@sapore-di-pane.com.ar";
    const floatingActionsStyle = {
        position: 'fixed',
        right: {xs: 16, sm: 20, md: 24},
        bottom: {xs: 16, sm: 20, md: 24},
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        gap: "15px",
        zIndex: theme.zIndex.modal + 2,
    };

    return (
        <div>
            <Navbar/>
            <Outlet/>
            <Footer/>
            <Box sx={floatingActionsStyle}>
                {showChatWidget && <ChatWidgetScreen/>}
                <WhatsAppButton isFixed={false}/>
            </Box>
        </div>
    )
}
